import { EditItem, IEditItem } from "ui/Scripts/source/models/common/editItem";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface IKeywordEditItem extends IEditItem {
    code: string;
    comment: string;
    modifyUser: IModifyUser;
}

export class KeywordEditItem extends EditItem implements IKeywordEditItem {
    code: string;
    comment: string;
    modifyUser: IModifyUser;

    constructor();
    constructor(obj: IKeywordEditItem);
    constructor(obj?: any) {
        super(obj);
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}